import { useNavigation } from '@react-navigation/native'
import React from 'react'

import { CoachReferralSponsoredView } from 'partials/CoachReferralSponsoredView'
import { CoachReferralView } from 'partials/CoachRreferralView'
import { Page } from 'partials/Page'
import { SignupForm } from 'partials/SignupForm'
import { SocialSignIn } from 'partials/SocialSignIn'

import { Box } from 'widgets/Box'
import { Icon } from 'widgets/Icon'
import { PressableText } from 'widgets/PressableText'
import { Text } from 'widgets/Text'

import { useAuth } from 'hooks/useAuth'
import { useCoachReferral } from 'hooks/useCoachReferral'
import { useFeatureFlags } from 'hooks/useFeatureFlags'

import { links } from 'utils/constants'

import { ShowUpText } from '../AuthWelcome/ShowUpText'

export const SignupPage = () => {
  const { signup } = useAuth()
  const coachReferral = useCoachReferral()
  const navigation = useNavigation<any>()

  const usernamePassword = signup?.usernamePassword
  const { isLoading, error } = usernamePassword

  const onSubmitSignupUsernamePassword = ({ email, password }: any) => {
    if (!email || !password) return

    usernamePassword.mutate({
      email, // test@example.com
      password, // TestingStrongPassword
    })
  }

  const onLoginPress = () => {
    navigation.navigate(links.LOGIN_PAGE)
  }

  const { isChallengeToggleEnabled } = useFeatureFlags()

  return (
    <Page withScroll backgroundColor='black'>
      <Box display='flex' flexDirection='column'>
        {coachReferral.isReferral && (
          <>
            <Box margin='xl' />
            {isChallengeToggleEnabled ? (
              <CoachReferralSponsoredView data={coachReferral} />
            ) : (
              <CoachReferralView data={coachReferral} />
            )}
          </>
        )}

        {!coachReferral.isReferral && (
          <Box
            testID='SignupPageInnerContainer'
            height={312}
            flexDirection='column'
            align='center'
            justifyContent='center'
          >
            <Box>
              <Box height={64} />
              <Icon color='v2primary' name='upspace-logo-mark' size={70} />
            </Box>
            <Box margin={{ top: 'sm' }}>
              <Icon color='white' name='upspace-word-mark' size={42} />
            </Box>
            <ShowUpText />
          </Box>
        )}

        <Box flex={1} flexDirection='column'>
          <Box>
            <Box margin={{ bottom: 'xl' }}>
              <SignupForm // Email, Password fields and Login button
                loading={isLoading}
                errors={error}
                onSubmit={onSubmitSignupUsernamePassword}
                isReferral={coachReferral.isReferral}
              />
            </Box>

            {/* Separator, Google and Facebook buttons */}
            <SocialSignIn mode='signup' />

            <Box
              testID='AccountMessageContainer'
              align='center'
              justifyContent='center'
              flexDirection='row'
              margin={{ horizontal: 'md', vertical: 'lg' }}
              height={50}
              borderRadius='sm'
              backgroundColor='black'
            >
              <Text color='greyDark' bold fontSize='sm' align='center'>
                {'Already have an account?  '}
              </Text>
              <PressableText bold fontSize='sm' color='v2primary' onPress={onLoginPress}>
                Login
              </PressableText>
            </Box>
          </Box>
        </Box>
      </Box>
    </Page>
  )
}
